import styled from 'styled-components';
import { Stack } from '@awaze/design-system.components.stack';
import { MEDIA_QUERY_BREAKPOINTS } from '@awaze/design-system.utils.react';
export const StackStyled = styled(Stack) `
  cursor: pointer;
  padding: 16px 0;
  align-items: center;

  /*
   ** The breakpoint is determined based on whether the mega menu or tablet view is enabled.
   ** The reason for this is that the opened mega menu has a fixed width of the full content width.
   ** If the screen was smaller, it would start to clip on the left and right.
   ** To circumvent this, we switch to a burger menu when the screen hits the minimum size it can populate without clipping.
   */
  @media screen and (min-width: ${({ showForTablet, showMegaMenu }) => showMegaMenu
    ? '1220'
    : showForTablet
        ? MEDIA_QUERY_BREAKPOINTS.tablet
        : MEDIA_QUERY_BREAKPOINTS.mobile}px) {
    display: none;
  }
`;
//# sourceMappingURL=burger.styles.js.map